import APIClient from '../../../lib/api';

class SettingsService {
  async getMyDataSettings() {
    try {
      const response = await APIClient.settings.getMyData();
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('SettingsService.getMyDataSettings Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης ρυθμίσεων MyData'
      };
    }
  }

  async updateMyDataSettings(useTestApi) {
    try {
      const response = await APIClient.settings.updateMyData({
        use_test_api: useTestApi
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('SettingsService.updateMyDataSettings Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης ρυθμίσεων MyData'
      };
    }
  }

  async getNotificationSettings() {
    try {
      const response = await APIClient.settings.getNotifications();
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('SettingsService.getNotificationSettings Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης ρυθμίσεων ειδοποιήσεων'
      };
    }
  }

  async updateNotificationSettings(settings) {
    try {
      const response = await APIClient.settings.updateNotifications(settings);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('SettingsService.updateNotificationSettings Error:', error);
      const detail = error.response?.data?.detail;
      return {
        success: false,
        error: Array.isArray(detail)
          ? detail.map((d) => d.msg || JSON.stringify(d)).join(', ')
          : (detail || error.message || 'Σφάλμα ενημέρωσης ρυθμίσεων ειδοποιήσεων')
      };
    }
  }
}

export default new SettingsService();
